var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPacemaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 62,
    viewBox: "0 0 46 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0313 38.9712C40.0313 35.4651 38.3563 32.2693 35.6073 29.864C37.6155 27.2238 39.7086 23.7057 41.5582 19.6913C45.9628 10.1328 47.3215 1.38242 44.5911 0.146107C41.8615 -1.0902 36.0788 5.65578 31.6726 15.2143C29.8877 19.0884 28.6034 22.8294 27.8876 25.9907C26.3396 25.6219 24.6986 25.4239 22.9994 25.4239C21.3002 25.4239 19.6592 25.6219 18.1104 25.9907C17.3954 22.8294 16.1103 19.0884 14.3254 15.2143C9.92161 5.65658 4.1381 -1.0894 1.40851 0.146908C-1.32109 1.38322 0.0368374 10.1336 4.4422 19.6921C6.29185 23.7065 8.38495 27.2246 10.3923 29.8648C7.64412 32.2701 5.96915 35.4659 5.96915 38.972C5.96915 39.6206 6.02577 40.258 6.13657 40.8809C3.94562 43.0425 2.66614 45.6482 2.66614 48.4535C2.66614 55.9347 11.7696 62 23.0002 62C34.2308 62 43.3343 55.9347 43.3343 48.4535C43.3343 45.6482 42.0548 43.0425 39.8638 40.8809C39.9738 40.2572 40.0313 39.6198 40.0313 38.9712Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPacemaker);
export default __webpack_public_path__ + "static/media/icon-pacemaker.3d10c80ca380d81c6b3d50ecdead62ee.svg";
export { ForwardRef as ReactComponent };